module.exports = __webpack_public_path__ + "img/why_icon.8342efe3.png";